module.exports = __webpack_public_path__ + "img/arrow-right.f4b1fb9f.svg";